import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { emptyObject } from 'ui-components/default-props/empty';
import Global from '../../../store/global-selectors';
import { REFUND_STATUS_TYPES } from '../../refund-status/refund-status-mappings';
import { messages } from '../messages';

export const REFUND_ASSIST_STATUS_IDS = [REFUND_STATUS_TYPES.PENDING, REFUND_STATUS_TYPES.APPROVED, REFUND_STATUS_TYPES.REJECTED];

const VoidTypeColumn = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? emptyObject;
  // will return null, undefined, or integer > 0
  const { shipmentRefundStatusTypeId } = fulfillment;

  return REFUND_ASSIST_STATUS_IDS.includes(shipmentRefundStatusTypeId) ? (
    <FormattedMessage {...messages.voidTypeRefundAssist} />
  ) : (
    <FormattedMessage {...messages.voidTypeManual} />
  );
};

export const VoidType = {
  getMessageDescriptor: () => messages.voidType,
  id: 'void-type',
  render: (data) => {
    if (!data) {
      return '';
    }
    return <VoidTypeColumn fulfillmentId={data.id} />;
  },
};
